import {makeLoader} from './makeLoader';

export const timezones = makeLoader('/timezones/get.json', 'timezones');
